import { render } from "./EphemeridesConfig.vue?vue&type=template&id=297b4f17"
import script from "./EphemeridesConfig.vue?vue&type=script&lang=js"
export * from "./EphemeridesConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__